import { clientEnv } from "../env";
import type { AiChatMessage } from "./ai.types";

export interface ConversationSummary {
  readonly id: string;
  readonly title: string;
  readonly createdAt: string;
  readonly updatedAt: string;
}

interface StoredMessage extends AiChatMessage {
  readonly id: string;
  readonly createdAt: string;
}

function headers(token: string): HeadersInit {
  return { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
}

async function readJson<T>(response: Response): Promise<T> {
  const payload = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(payload.error ?? "No se pudo acceder al historial.");
  return payload;
}

export async function listConversations(token: string): Promise<ConversationSummary[]> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/conversations`, { headers: headers(token) });
  return (await readJson<{ conversations: ConversationSummary[] }>(response)).conversations;
}

export async function createConversation(token: string): Promise<ConversationSummary> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/conversations`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify({ title: "Nueva conversación" })
  });
  return (await readJson<{ conversation: ConversationSummary }>(response)).conversation;
}

export async function getConversationMessages(token: string, conversationId: string): Promise<StoredMessage[]> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/conversations/${conversationId}/messages`, {
    headers: headers(token)
  });
  return (await readJson<{ messages: StoredMessage[] }>(response)).messages;
}

export async function saveConversationMessage(
  token: string,
  conversationId: string,
  message: AiChatMessage
): Promise<void> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/conversations/${conversationId}/messages`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(message)
  });
  await readJson(response);
}
